module.exports = __webpack_public_path__ + "static/img/motiverse_symbol.9cb6cb24.png";